/**
 * 各运营菜单对应的固定账本筛选（复用 LedgerSubsetPage）。
 */
import { LedgerSubsetPage } from './LedgerSubsetPage';

export function ReferralBonusLedgerPage() {
  return <LedgerSubsetPage title="推荐奖励流水" actions="referral_bonus" />;
}

export function LevelBonusLedgerPage() {
  return <LedgerSubsetPage title="等级奖励流水" actions="level_bonus" />;
}

export function NodeBonusLedgerPage() {
  return (
    <LedgerSubsetPage
      title="节点/复合奖励流水"
      actions="referral_bonus,level_bonus"
      subtitle="含推荐奖励与等级奖励账本条目。"
    />
  );
}

export function ForkLogLedgerPage() {
  return <LedgerSubsetPage title="分红记录（账本）" actions="fork_event" />;
}
